/*
  Filter Daddy finder — matches the React demo.
  Room is always selected. Concerns are optional multi-select chips.
  The match card updates live from pre-rendered product cards.
*/
class FdFilterFinder extends HTMLElement {
  connectedCallback() {
    this.results = Array.from(this.querySelectorAll('[data-fd-result]'));
    this.onChange = this.onChange.bind(this);
    this.addEventListener('change', this.onChange);
    this.addEventListener('click', this.onChipClick.bind(this));
    this.match();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.onChange);
  }

  get room() {
    const checked = this.querySelector('input[name="fd-room"]:checked');
    return checked ? checked.value : 'kitchen';
  }

  get concerns() {
    return Array.from(this.querySelectorAll('input[name="fd-concern"]:checked')).map((el) => el.value);
  }

  onChipClick(event) {
    const chip = event.target.closest('[data-fd-chip]');
    if (!chip) return;
    const input = chip.querySelector('input');
    if (!input) return;
    if (event.target === input) return;
    event.preventDefault();
    input.checked = !input.checked;
    this.match();
  }

  onChange(event) {
    if (event.target && event.target.name === 'fd-room') {
      this.querySelectorAll('input[name="fd-concern"]').forEach((el) => {
        el.checked = false;
      });
      this.querySelectorAll('[data-fd-concern-set]').forEach((el) => {
        el.hidden = el.dataset.fdConcernSet !== this.room;
      });
    }
    this.match();
  }

  match() {
    const room = this.room;
    const concerns = this.concerns;
    let best = null;
    let bestScore = -1;

    this.results.forEach((el) => {
      if (el.dataset.room !== room) {
        el.hidden = true;
        return;
      }
      const tags = (el.dataset.concerns || '').split(',').filter(Boolean);
      const score = concerns.length === 0 ? 0 : concerns.filter((c) => tags.includes(c)).length;
      if (score > bestScore) {
        bestScore = score;
        best = el;
      }
    });

    this.results.forEach((el) => {
      el.hidden = el !== best;
    });
  }
}

if (!customElements.get('fd-filter-finder')) {
  customElements.define('fd-filter-finder', FdFilterFinder);
}
